import {Component, DoCheck, Input, KeyValueDiffers, OnInit, Output, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {DataSharingService} from '../../services/data-sharing.service';
import {Store} from '@ngxs/store';
import {UtilService} from '../../services/UtilService';

@Component({
  selector: 'app-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss']
})
export class TabBarComponent implements OnInit, DoCheck {

  @Input() tabs = [''];
  @Input() currentTab = '';
  @Input() dynamicTabs = true;
  @Output() updateCurrentIndex = new EventEmitter<string>();
  chartFilters = [];
  reservedTabNames = ['home', 'screener', 'documentation', 'trs calculator'];

  differ: any;
  indexType = '';

  constructor(private differs: KeyValueDiffers, private route: Router, private shareService: DataSharingService,
              private store: Store, private utilService: UtilService) {
    this.differ = this.differs.find({}).create();
  }

  ngOnInit(): void {
    this.store.select(state => state.indexState.stateName).subscribe((resp: any) => {
      this.indexType = resp;
    });
  }

  ngDoCheck(): void {
    const change = this.differ.diff(this);
    if (change) {
      change.forEachChangedItem((item: any) => {
        if (this.dynamicTabs) {
          this.shareService.tabList.next(this.tabs);
          if (window.location.href.includes('iBoxx')) {
            this.utilService.saveTabListFor(this.indexType, this.tabs);
          }
          if (window.location.href.includes('Carbon')) {
            window.sessionStorage.setItem('tabListForCarbon', JSON.stringify(this.tabs));
          }
        }
        this.shareService.isinSource.next(item.currentValue);
      });
    }
  }

  openTab(tab: string): void {
    this.currentTab = tab;
    this.updateCurrentIndex.emit(tab);
    if (this.dynamicTabs) {
      this.shareService.currentTab = tab;
    }
  }

  closeTab(tab: string): void {
    // @ts-ignore
    this.chartFilters = JSON.parse(localStorage.getItem('chartFilterOptions')) ? JSON.parse(localStorage.getItem('chartFilterOptions'))
      : [];

    let currentID = '';
    if (tab !== 'screener' && tab !== 'home'){
      if (window.location.href.includes('iBoxx')){
        currentID = this.shareService.headlineIndices.find((index: any) =>
          index.indexName === tab.split('?')[0] && index.inflationAdjustment === tab.split('?')[1]).id;
      }
      if (window.location.href.includes('Carbon')){
        currentID = tab.split(' :')[0];
      }
      if (window.location.href.includes('EMIX')){
        currentID = this.shareService.EMIXIndices.indexLevels.find((level: any) =>
          tab === (level.indexName + ' (' + level.currency + ')')).id;
      }
    }
    const optionIndex = this.chartFilters.findIndex((filter: any) => filter.id === currentID);
    if (optionIndex > -1) {
      this.chartFilters.splice(optionIndex, 1);
    }
    localStorage.setItem('chartFilterOptions', JSON.stringify(this.chartFilters));
    this.tabs.splice(this.tabs.indexOf(tab), 1);
    if (window.location.href.includes('iBoxx')) {
      this.utilService.saveTabListFor(this.indexType, this.tabs);
    }
    if (window.location.href.includes('Carbon')) {
      window.sessionStorage.setItem('tabListForCarbon', JSON.stringify(this.tabs));
    }
    if (window.location.href.includes('EMIX')) {
      window.sessionStorage.setItem('tabListForEMIX', JSON.stringify(this.tabs));
    }
    if (tab === this.currentTab) {
      if (window.location.href.includes('iBoxx')) {
        switch (this.indexType) {
          case 'all':
            this.route.navigateByUrl('iBoxx/Screener');
            break;
          case 'futures':
            this.route.navigateByUrl('iBoxx/Futures/Screener');
            break;
          case 'trs':
            this.route.navigateByUrl('iBoxx/TRS/Screener');
            break;
          case 'esg':
            this.route.navigateByUrl('iBoxx/ESG/Screener');
            break;
        }
      }
      if (window.location.href.includes('Carbon')) {
        this.route.navigateByUrl('/Carbon/Home');
      }
      if (window.location.href.includes('EMIX')) {
        this.route.navigateByUrl('/EMIX/Screener');
      }
    }
  }
}
